import { useContext } from "react"
import { LocalizationContext } from "./LocalizationContext"
import { ILocalizationContext } from "."

export function useLocalization() {
    return useContext<ILocalizationContext>(LocalizationContext)
}
